import { render } from "./globaldashboardHead.vue?vue&type=template&id=65cd7605"
import script from "./globaldashboardHead.vue?vue&type=script&lang=js"
export * from "./globaldashboardHead.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__